interface useCurrencyType {
  getCurrency: (value?: string) => ICurrencyType;
}
export interface ICurrencyType {
  name?: string;
  code: string;
  sign: string;
  decimals?: number; // Number of decimal places to display (default: 2)
}

const useCurrency = (): useCurrencyType => {
  const currencies = {
    BR: { name: "Real", code: "BRL", sign: "R$", decimals: 2 },
    CO: { name: "Peso Colombiano", code: "COP", sign: "$", decimals: 0 },
    EC: { name: "Dólar Americano", code: "USD", sign: "$", decimals: 2 },
    ID: { name: "Rupiah", code: "IDR", sign: "Rp", decimals: 0 },
    MX: { name: "Peso Mexicano", code: "MXN", sign: "$", decimals: 2 },
    PA: { name: "US Dollar", code: "USD", sign: "$", decimals: 2 },
    PE: { name: "Sol", code: "PEN", sign: "S/", decimals: 2 },
    PH: { name: "Philippine peso", code: "PHP", sign: "₱", decimals: 2 },
    US: { name: "US Dollar", code: "USD", sign: "$", decimals: 2 },
    ZA: { name: "Rand", code: "ZAR", sign: "R", decimals: 2 },
  };
  const getCurrency = (countryIso = "MX") => currencies[countryIso];

  return {
    getCurrency,
  };
};

export default useCurrency;
